<template>
  <MainLayout>
    <ContentPageHeader functionName="棚卸管理" pageName="棚卸開始登録">
    </ContentPageHeader>
    
    <div class="inventory-start-register-form">
      <div class="form-section">
        <!-- 棚卸日 -->
        <FormDisplayField 
          label="棚卸日"
          id="inventoryDate" 
          :value="inventory.inventoryDate"
        />

        <!-- 備考 -->
        <FormTextareaField 
          label="備考" 
          id="note" 
          v-model="inventory.note"
          :rows="4"
        />
      </div>
    </div>
    
    <template #footer-buttons>
      <div class="footer-buttons">
        <button class="btn btn-primary" @click="registerInventory">登録</button>
      </div>
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import FormDisplayField from '@/components/form/FormDisplayField.vue'
import FormTextareaField from '@/components/form/FormTextareaField.vue'
import { showLoading, hideLoading } from '@/utils/loadingEventBus';
import service from '../../services/service';

export default {
  name: 'InventoryStartRegisterView',
  components: {
    MainLayout,
    ContentPageHeader,
    FormDisplayField,
    FormTextareaField,
  },
  data() {
    return {
      inventory: {
        inventoryDate: '',
        note: '',
      }
    };
  },
  computed: {
    defaultInventory() {
      const today = new Date();
      const year = today.toLocaleString('ja-JP', { year: 'numeric' });
      const month = today.toLocaleString('ja-JP', { month: '2-digit' });
      const day = today.toLocaleString('ja-JP', { day: '2-digit' });
      const formattedDate = `${year}${month}${day}`;
      
      return {
        inventoryDate: formattedDate,
        note: ''
      };
    },
    
    // ユーザーの所属店舗ID
    userStoreId() {
      return this.$store.getters['auth/currentUser']?.storeId || null;
    },
  },
  methods: {
    async validationCheck() {
      if (this.inventory.note && 1000 < this.inventory.note.length) {
        return '備考は1000文字以内で入力してください';
      }
      
      // 棚卸情報取得APIを呼び出して本日の棚卸データが既に存在するかチェック
      try {
        const response = await service.getCurrentInventory(this.userStoreId);
        if (response.data.success && response.data.inventoryId) {
          const inventoryDate = new Date(response.data.inventoryDate);
          const today = new Date();
          
          // 年月日が同じかチェック
          if (inventoryDate.getFullYear() === today.getFullYear() &&
              inventoryDate.getMonth() === today.getMonth() &&
              inventoryDate.getDate() === today.getDate()) {
            return '棚卸データが既に存在します';
          }
        }
      } catch (error) {
        console.error('棚卸情報の取得に失敗しました', error);
        return '棚卸情報の取得中にエラーが発生しました';
      }
      
      return null;
    },
    
    async registerInventory() {
      try {
        showLoading();
        const errorMessage = await this.validationCheck();
        if (errorMessage != null) {
          alert(errorMessage);
          return;
        }
        
        if (!confirm('棚卸情報を登録します。\nよろしいですか？')) return;

        // 現在の日付をLocalDateTime形式で送信
        const today = new Date();
        const inventoryRequest = {
          storeId: this.userStoreId,
          inventoryDate: today.toISOString(),
          note: this.inventory.note
        };

        const response = await service.registerInventory(inventoryRequest);
        
        if (response.data && response.data.isSuccess) {
          alert('棚卸開始登録が完了しました。');
          
          this.$router.push({ name: 'InventoryList' });
        } else {
          throw new Error(response.data?.message || '棚卸開始情報の登録中にエラーが発生しました。');
        }
      } catch (error) {
        alert('棚卸開始情報の登録中にエラーが発生しました。');
        console.error('棚卸登録エラー:', error);
      } finally {
        hideLoading();
      }
    }
  },
  mounted() {
    this.inventory = this.defaultInventory;
  }
}
</script>

<style scoped>
.inventory-start-register-form {
  display: flex;
  flex-direction: column;
  background-color: var(--gray-light);
}

.form-section {
  background-color: var(--gray-light);
  padding: 0;
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 0;
}
</style>
